import { CheckOrderStatusCode, checkOrderStatusLabels } from 'types';

export const StatusBadge: React.FC<{ status: CheckOrderStatusCode }> = ({ status }) => {
  let statusColor: string = '';
  if (status === CheckOrderStatusCode.CHECKING) statusColor = 'bg-[var(--primaryColor500)] text-white';
  else if (status === CheckOrderStatusCode.CHECKED) statusColor = 'bg-[var(--sematicSuccessColor500)] text-white';
  else statusColor = 'bg-[var(--textBlack24)] text-[var(--textBlack)]';
  return (
    <div
      className={
        `inline-block font-medium  text-[14px] leading-[20px] px-4 py-1 rounded-full ${statusColor} ` + statusColor
      }
    >
      {checkOrderStatusLabels[status]}
    </div>
  );
};
